<template>
    <div id="magic-zoom">
        <div itemscope itemtype="http://schema.org/Thing">
            <div class="ItemImgWrap justify-content-center" :class="{'more-images': magiczoom.images.all.length > 1 }">
                <template v-if="magiczoom.images.all.length > 1">
                    <div class="magic-more-images d-none d-lg-block" v-if="magiczoom.images.all.length >= 4">
                        <div @click="slidePrev" class="text-center fa-lg mb-2 cursor" v-if="magiczoom.images.all.length > 4">
                            <i class="fa fa-angle-right fa-rotate-270 flipiconZoom "></i>
                        </div>
                        <hooper class="d-none d-lg-block" :vertical="true" :infiniteScroll="false" :itemsToShow="4" :trimWhiteSpace="true" ref="carousel">
                            <slide v-if="ytvideo !=''">
                                <a class="border video d-flex mb-2 videoImage cursor" @click="showVideo()" @mouseover.once="$store.dispatch('loadComponent', 'yt-video')">
                                    <i class="fa fa-play-circle-o" v-if="!loading"></i>
                                    <i class="fa fa-circle-o-notch fa-spin" v-else></i>
                                </a>
                            </slide>
                            <slide v-for="(imagePreview, index) in magiczoom.images.all">
                                <a :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].urlSecondPreview" class="border">
                                    <img
                                        :data-src="imagePreview.url"
                                        :src="imagePreview.urlPreview">
                                </a>
                            </slide>
                        </hooper>
                        <div @click="slideNext" class="text-center fa-lg cursor" v-if="magiczoom.images.all.length > 4">
                            <i class="fa fa-angle-right fa-rotate-90"></i>
                        </div>
                    </div>
                    <div class="magic-more-images d-none d-lg-block" v-else>
                        <template v-if="ytvideo !=''">
                            <a class="border video d-flex mb-2 videoImage" @click="showVideo()" @mouseover.once="$store.dispatch('loadComponent', 'yt-video')">
                                <i class="fa fa-play-circle-o" v-if="!loading"></i>
                                <i class="fa fa-circle-o-notch fa-spin" v-else></i>
                            </a>
                        </template>
                        <template v-for="(imagePreview, index) in magiczoom.images.all">
                            <a :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].urlMiddle" class="mb-2 border">
                                <img
                                    :data-src="imagePreview.url"
                                    :src="imagePreview.urlPreview">
                            </a>
                        </template>
                    </div>
                </template>
                <button class="zoom-xs-left d-lg-none" @click="prevNext('left')">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                </button>
                <a :href="magiczoom.images | itemImages('url') | itemImage" id="ItemImgZoom" class="MagicZoomPlus flex-fill d-flex align-items-start justify-content-center"
                   :data-mobile-options="'zoomMode:off; lazyZoom: true; textTouchZoomHint:'+  $translate('Klettershop5::Template.singleZoomHint') +'; textClickZoomHint: '+ $translate('Klettershop5::Template.singleZoomHint2') +'; textExpandHint: '+$translate('Klettershop5::Template.singleZoomHint')"
                   :data-options="'lazyZoom: true;cssClass: white-bg; zoom-height:500px; textHoverZoomHint:'+$translate('Klettershop5::Template.singleZoomHint3')+'; textExpandHint:'+ $translate('Klettershop5::Template.singleZoomHint3')+'; zoomPosition: #zoom-placeholder;'">
                    <img  class="img-fluid" :src="magiczoom.images | itemImages('urlSecondPreview') | itemImage" itemprop="image">
                </a>
                <button class="zoom-xs-right d-lg-none" @click="prevNext('right')">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                </button>
            </div>
            <div class="zoom-navigation-dots d-md-none">
            </div>
        </div>
        <video-container :yt="ytvideo"></video-container>
    </div>
</template>

<script>
    import { Hooper, Slide  } from 'hooper';
    export default
    {
        name:'magic-zoom',
        components: { Hooper, Slide },
        props:
        {
            template:
            {
                type: String,
                default: "#vue-magic-zoom"
            }
        },
        inject:
        {
            itemId:
            {
                default: null
            }
        },
        data: function()
        {
            return {
                onloadVarId: this.currentVariation().variation.id,
                dotsCount: 0,
                loading:false,
                youtubeid:''
            }
        },
        methods:
        {
            prevNext(direction)
            {
                if(direction=="left")
                {
                    MagicZoom.prev('ItemImgZoom');
                }
                else if(direction=="right")
                {
                    MagicZoom.next('ItemImgZoom');
                }
                else
                {
                    console.log('unknown direction');
                }

            },
            showVideo:function()
            {
                setTimeout(function () {
                    $('#video-modal-dk').modal('show')
                },500)
                vueEventHub.$emit("showvideo",true);
            },
            searchVideo()
            {
                let currentVariation = this.currentVariation();
                if(currentVariation.hasOwnProperty('variationProperties'))
                {
                    for(let i=0; i < currentVariation.variationProperties.length; i++)
                    {
                        if(currentVariation.variationProperties[i].id == 7)
                        {
                            for(let v=0; v < currentVariation.variationProperties[i].properties.length; v++)
                            {
                                if(currentVariation.variationProperties[i].properties[v].id == 32)
                                {
                                    if(currentVariation.variationProperties[i].properties[v].values.value !="")
                                    {
                                        this.youtubeid = currentVariation.variationProperties[i].properties[v].values.value;
                                    }
                                }
                            }
                        }
                    }
                    return this.youtubeid;
                }
                else
                {
                    return '';
                }
            },
            currentVariation: function()
            {
                return this.$store.getters[`${this.itemId}/currentItemVariation`];
            },
            slideNext() {
                this.$refs.carousel.slideNext();
            },
            slidePrev() {
                this.$refs.carousel.slidePrev();
            }
        },
        computed:
        {

            magiczoom: function()
            {
                return this.currentVariation();
            },
            ytvideo:function()
            {
                return this.searchVideo();
            }

        }
    }
</script>
